<template>
  <img :src="getImgUrl(imaSrc)" :alt="imaAlt" :style="styleObject">
</template>

<script>
import imaDynamic from "../../js/mixins/imadynamic";
export default {
  props: {
    imaSrc: {
      Type: String,
      required: true
    },
    imaAlt: {
      Type: String,
      required: true
    },
    imaSize: {
      Type: Number,
      required: false
    }
  },
  data() {
    return {
      styleObject: {
        maxWidth: this.imaSize + "px",
        width: this.imaSize ? "100%" : "auto"
      }
    };
  },
  mixins: [imaDynamic]
};
</script>

<style lang="scss" scoped>
@import "../../sass/helpers/mixins";
</style>


// WEBPACK FOOTER //
// Imageimport.vue?2363c868